import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initElyonSessionReplay } from "./elyonSessionReplay";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

initElyonSessionReplay({ proxyUrl: "/api/telemetry/session-events" });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();
